// The component is responsible for displaying individual items or
// services within the slider. Each tile includes an image, link, with clickable elements wrapped in Link
// components for navigation. Its purpose is to provide users with detailed information about
// a specific service or product, making it visually accessible and easily navigable within
// the carousel structure.

import React from 'react';
import Link from 'next/link';
import { useFormat } from 'helpers/hooks/useFormat';
import { CarouselContentItem } from 'types/next';
import { SmartLink } from 'components/commercetools-ui/atoms/smart-link';
interface TileProps {
  data: CarouselContentItem;
  locale: 'en-GB' | 'en-EU';
}

const CategoryTile: React.FC<TileProps> = ({ data, locale }) => {
  const image = data?.image?.[locale];
  const link = data?.link?.[locale] || '';
  const name = data.name?.[locale] || '';
  return (
    <div className="flex flex-col items-center">
      <SmartLink href={link || ''}>
        {image && (
          <img
            src={`https://${image?.defaultHost}/i/${image?.endpoint}/${image?.name}`}
            alt={name}
            className="w-[100%] pb-15"
          />
        )}
      </SmartLink>
    </div>
  );
};

export default CategoryTile;
